import React, { useState, useEffect } from "react";
import AdditionaLInfo from "../../../entities/AccountSettings/AdditionalInformation";
import AuthService from "../../../api/AuthService";
import LoaderHelper from "../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../context/AlertContext";
import { allowanceTypeService } from "../../../api";
import { useLocation } from "react-router-dom";
import { setDateFormat } from "../../../utils/dateFormatStore";

const AdditionalInfo = () => {
  const { showAlert } = useAlert();
  const [open, setOpen] = useState(false);
  const [utopen, setUtOpen] = useState(false);
  const [dpopen, setDpOpen] = useState(false);
  const [roleOpen, setRoleOpen] = useState(false);
  const [pensionopen, setPensionOpen] = useState(false);
  const [deductionOpen, setDeductionOpen] = useState(false);
  const [fringeOpen, setFringeOpen] = useState(false);
  const [allowanceOpen, setAllowanceOpen] = useState(false)
  const [leaveData, setleaveData] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [holidayType, setHolidayType] = useState([]);
  const [pension, setPension] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const [unitData, setUnitData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [operatorEmployees, setOperatorEmployees] = useState([]);
  const [deductionData, setDeductionData] = useState([]);
  const [fringeData, setFringeData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  const [payslipShow, setPayslipShow] = useState([]);
  const [payslipData, setPayslipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingUt, setLoadingUt] = useState(false);
  const [taxOpen, setTaxOpen] = useState(false);
  const [holidayOpen, setHolidayOpen] = useState(false);
  const [allowanceType, setAllowanceType] = useState([])
  const [contributionType, setContributionsType] = useState([])
  const [contributionsOpen, setContributionsOpen] = useState(false)
  const [leviesType, setLeviesType] = useState([])
  const [creditType, setCreditType] = useState([])
  const [numberFormats, setNumberFormats] = useState({
    employeePrefix: "",
    employeeCounter: "",
    payslipPrefix: "",
    payslipCounter: "",
    dateFormat: "DD/MM/YYYY",
  });
  const [numberFormatsOriginal, setNumberFormatsOriginal] = useState(null);
  const [numberFormatErrors, setNumberFormatErrors] = useState({
    employeePrefix: "",
    employeeCounter: "",
    payslipPrefix: "",
    payslipCounter: "",
    dateFormat: "",
  });
  const [isNumberFormatValid, setIsNumberFormatValid] = useState(false);
  const [isNumberFormatDirty, setIsNumberFormatDirty] = useState(false);
  const [settingsId, setSettingsId] = useState("");
  const [numberFormatsLoading, setNumberFormatsLoading] = useState(false);
  const [numberFormatsSaving, setNumberFormatsSaving] = useState(false);
  const [accountCountry, setAccountCountry] = useState(
    () => localStorage.getItem("companyCountry") || localStorage.getItem("country") || ""
  );
  const [marketingReceive, setMarketingReceive] = useState(true); // default true
  const [marketingLoading, setMarketingLoading] = useState(false);
  const companyId = localStorage.getItem("companyId") || '';

  const location = useLocation();
  const { companyToken } = location.state || {};

  const getListFromResponse = (data, keys = []) => {
    if (Array.isArray(data)) return data;

    for (const key of keys) {
      if (Array.isArray(data?.[key])) return data[key];
    }

    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.data?.docs)) return data.data.docs;
    if (Array.isArray(data?.data?.results)) return data.data.results;

    return [];
  };

  useEffect(() => {
    getUnitType();
    getOperators();
    getDepartment();
    getScheduleTime();
    getPensionType();
    getDeductionType();
    getFringeType();
    getTaxYear();
    getPayslip();
    getHoliday();
    getPayslipShow();
    getAllowanceType();
    getContributionsType();
    getLeviesType();
    getCreditType();
    getCompanySettingsConfig();
    getAccountSettings();
    getMarketingNotification(companyId);
  }, []);

  useEffect(() => {
    getLeaveType();
  }, [accountCountry]);

  const getLeaveType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const country = accountCountry || "";
      const result = await AuthService.getAllLeaveTypeForAdmin(country);
      if (result?.success) {
        setleaveData(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getPayslipShow = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipShow(companyToken);
      if (result?.success) {
        setPayslipShow(result?.data[0]);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handlePayslipShow = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleShowPayslip(data);
      if (result?.success === true) {
        setLoading(false);

        getPayslipShow();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const handlePayslipShowEmptyValues = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleShowPayslipEmptyValues(data);
      if (result?.success === true) {
        setLoading(false);
        getPayslipShow();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const handleLeaveType = async (leave, isPaid) => {
    setLoading(true);
    try {
      const result = await AuthService.handleAccountLeaveType(leave, isPaid);
      if (result?.success === true) {
        setLoading(false);
        setOpen(false);

        getLeaveType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const deleteLeaveType = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteAccountLeaveType(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getLeaveType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const updateLeaveType = async (leave, id, isPaid) => {
    setLoading(true);
    try {
      const result = await AuthService.updateLeaveType(leave, id, isPaid);
      if (result?.success === true) {
        setLoading(false);
        setOpen(false);

        getLeaveType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const getHoliday = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getHoliday(companyToken);
      if (result?.success) {
        setHoliday(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getHolidayType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getHolidayType();
      if (result?.success) {
        setHolidayType(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleHoliday = async (date, end, type, desc) => {
    setLoading(true);
    try {
      const result = await AuthService.handleHoliday(date, end, type, desc);
      if (result?.success === true) {
        setLoading(false);
        setHolidayOpen(false);
        getHoliday();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const deleteHoliday = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteHoliday(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getHoliday();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const updateHoliday = async (date, end, type, desc, id) => {
    setLoading(true);
    try {
      const result = await AuthService.updateHoliday(date, end, type, desc, id);
      if (result?.success === true) {
        setLoading(false);
        setHolidayOpen(false);
        getHoliday();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const getPensionType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPensionType();
      if (result?.success) {
        setPension(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handlePensionType = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handlePensionType(data);
      if (result?.success === true) {
        setLoading(false);
        setPensionOpen(false);

        getPensionType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const deletePensionType = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deletePensionType(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getPensionType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const updatePensionType = async (data, id) => {
    setLoading(true);
    try {
      const result = await AuthService.updatePensionType(data, id);
      if (result?.success === true) {
        setLoading(false);
        setPensionOpen(false);

        getPensionType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const getUnitType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAccountUnitType(companyToken);
      if (result?.success) {
        setUnitData(result?.data?.units);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAddiInfoDepartment(companyToken);
      if (result?.success) {
        setDepartmentData(result?.data?.position);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getOperators = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOperators(1, 10, true, companyToken);
      if (result?.success) {
        setOperatorData(
          getListFromResponse(result?.data, [
            "operators",
            "operator",
            "docs",
            "results",
          ])
        );

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getOperatorEmployees = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOperatorEmployees(companyToken);
      if (result?.success) {
        setOperatorEmployees(
          getListFromResponse(result?.data, [
            "employees",
            "operators",
            "docs",
            "results",
          ])
        );

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleUnitType = async (unit) => {
    setLoadingUt(true);
    try {
      const result = await AuthService.handleAccountUnitType(unit);
      if (result?.success === true) {
        setLoadingUt(false);
        setUtOpen(false);

        getUnitType();
        showAlert(result?.message, "success");
      } else {
        setLoadingUt(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoadingUt(false);
      showAlert(error, "error");
    }
  };
  const handleDepartment = async (department, active) => {
    setLoading(true);
    try {
      const result = await AuthService.handleDepartment(department, active);
      if (result?.success === true) {
        setLoading(false);
        setDpOpen(false);

        getDepartment();
        showAlert(result?.message, "success");
      } else {
        setLoadingUt(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoadingUt(false);
      showAlert(error, "error");
    }
  };
  const createOperator = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.createOperator(data);
      if (result?.success === true) {
        setLoading(false);
        getOperators();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
      return result;
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
      return { success: false };
    }
  };
  const deleteUnitType = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteAccountUnitType(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getUnitType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const deleteDepartment = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteDepartment(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getDepartment();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const deleteOperator = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteOperator(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getOperators();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const updateUnitType = async (unit, id) => {
    setLoading(true);
    try {
      const result = await AuthService.updateUnitType(unit, id);
      if (result?.success === true) {
        setLoading(false);

        getUnitType();
        showAlert(result?.message, "success");
        setUtOpen(false);
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const updateDepartment = async (department, active, id) => {
    setLoading(true);
    try {
      const result = await AuthService.updateDepartment(department, active, id);
      if (result?.success === true) {
        setLoading(false);
        setDpOpen(false);

        getDepartment();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const updateOperator = async (id, data) => {
    setLoading(true);
    try {
      const result = await AuthService.updateOperator(id, data);
      if (result?.success === true) {
        setLoading(false);
        getOperators();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
      return result;
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
      return { success: false };
    }
  };
  const getScheduleTime = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSchedule(companyToken);
      if (result?.success) {
        setScheduleData(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleScheduleTime = async (schedule) => {
    setLoading(true);
    try {
      const result = await AuthService.handleScheduleTime(schedule);
      if (result?.success === true) {
        setLoading(false);

        showAlert(result?.message, "success");
        getScheduleTime();
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const getDeductionType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getASDeductionType(companyToken);
      if (result?.success) {
        setDeductionData(result?.data?.deductions);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleDeductionType = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleASDeductionType(data);
      if (result?.success === true) {
        setLoading(false);
        setDeductionOpen(false);

        getDeductionType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const deleteDeductionType = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteASDeductionType(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getDeductionType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const updateDeductionType = async (data, id) => {
    setLoading(true);
    try {
      const result = await AuthService.updateASDeductionType(data, id);
      if (result?.success === true) {
        setLoading(false);
        setDeductionOpen(false);
        getDeductionType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const getFringeType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAddiInfoFringeType(companyToken);
      if (result?.success) {
        setFringeData(result?.data?.fringes);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleFringeType = async (data, fringeTax) => {
    setLoading(true)
    try {
      const result = await AuthService.handleASFringeType(data, fringeTax);
      if (result?.success === true) {
        setLoading(false);
        setFringeOpen(false);

        getFringeType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const deleteFringeType = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteASFringeType(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getFringeType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const updateFringeType = async (data, id, fringeTax) => {
    setLoading(true);
    try {
      const result = await AuthService.updateASFringeType(data, id, fringeTax);
      if (result?.success === true) {
        setLoading(false);
        setFringeOpen(false);
        getFringeType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const getTaxYear = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAddiInfoTaxYear(companyToken);
      if (result?.success) {
        setTaxData(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleTaxYear = async (start, end) => {
    setLoading(true);
    try {
      const result = await AuthService.handleTaxYear(start, end);
      if (result?.success === true) {
        setLoading(false);
        setTaxOpen(false);

        getTaxYear();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const deleteTaxYear = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteTaxYear(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getTaxYear();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const updateTaxYear = async (start, end, id) => {
    setLoading(true);
    try {
      const result = await AuthService.updateTaxYear(start, end, id);
      if (result?.success === true) {
        setLoading(false);
        setTaxOpen(false);
        getTaxYear();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const getPayslip = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getASPayslip(companyToken);
      if (result?.success) {
        setPayslipData(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handlePayslip = async (settings, payeName, payslipData) => {
    setLoading(true);
    try {
      const result = await AuthService.handleASPayslip(
        settings,
        payeName,
        payslipData
      );
      if (result?.success === true) {
        setLoading(false);

        getPayslip();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };


  const getAllowanceType = async (page = 1, sort = "") => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await allowanceTypeService.get(page, sort, companyToken);
      if (result?.success) {
        setAllowanceType(result?.data?.allowance);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };

  const handleAddAllowance = async (data, fringeTax) => {
    setLoading(true)
    try {
      const result = await allowanceTypeService.post(data, fringeTax, accountCountry);
      if (result?.success === true) {
        setLoading(false);
        setAllowanceOpen(false);
        getAllowanceType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const updateAllowanceType = async (data, id, allowanceText) => {
    setLoading(true);
    try {
      const result = await allowanceTypeService.put(data, id, allowanceText, accountCountry);
      if (result?.success === true) {
        setLoading(false);
        setAllowanceOpen(false);
        getAllowanceType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const deleteAllowanceType = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await allowanceTypeService.delete(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getAllowanceType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getContributionsType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAddiInfoContributionsType(companyToken);
      if (result?.success) {
        setContributionsType(result?.data?.contributions);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddContributions = async (contribution, contributionText) => {
    setLoading(true)
    try {
      const result = await allowanceTypeService.ContributionsPost(contribution, contributionText);
      if (result?.success === true) {
        setLoading(false);
        setContributionsOpen(false);
        getContributionsType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const updateContributions = async (contribution, editContribution, contributionText) => {
    setLoading(true);
    try {
      const result = await allowanceTypeService.contributionsPut(contribution, editContribution, contributionText);
      if (result?.success === true) {
        setLoading(false);
        getContributionsType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const deleteContributions = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await allowanceTypeService.contributionsDelete(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getContributionsType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getLeviesType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getLeviesTypes(companyToken);
      if (result?.success) {
        setLeviesType(result?.data?.levies);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddLevies = async (levies, leviesText) => {
    setLoading(true)
    try {
      const result = await allowanceTypeService.LeviesPost(levies, leviesText);
      if (result?.success === true) {
        setLoading(false);
        getLeviesType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const updateLevies = async (levies, editLevies, leviesText) => {
    setLoading(true);
    try {
      const result = await allowanceTypeService.leviesPut(levies, editLevies, leviesText);
      if (result?.success === true) {
        setLoading(false);
        getLeviesType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const deleteLevies = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await allowanceTypeService.leviesDelete(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getLeviesType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getCreditType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAddiInfoCreditsType(companyToken);
      if (result?.success) {
        setCreditType(result?.data?.credits);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddCreditType = async (creditTypeName, includeBenificiary) => {
    setLoading(true)
    try {
      const result = await AuthService.addCreditsType(creditTypeName, includeBenificiary);
      if (result?.success === true) {
        setLoading(false);
        getCreditType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const updateCreditType = async (creditTypeName, creditTypeId, includeBenificiary) => {
    setLoading(true);
    try {
      const result = await AuthService.updateCreditsType(creditTypeName, creditTypeId, includeBenificiary);
      if (result?.success === true) {
        setLoading(false);
        getCreditType();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const deleteCreditType = async (creditTypeId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteCreditsType(creditTypeId);
      if (result?.success) {
        showAlert(result?.message, "success");
        getCreditType();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const MIN_PREFIX_LENGTH = 2;
  const MAX_PREFIX_LENGTH = 6;

  const sanitizePrefixValue = (value = "") =>
    value.toUpperCase().replace(/[^A-Z]/g, "").slice(0, MAX_PREFIX_LENGTH);

  const ALLOWED_DATE_FORMATS = [
    "DD/MM/YYYY",
    "DD/MM/YY",
    "YYYY/MM/DD",
    "YY/MM/DD",
    "DD MMM YYYY",
    "MMM DD, YYYY",
  ];

  const validateNumberFormats = (formats) => {
    const errors = {
      employeePrefix: "",
      employeeCounter: "",
      payslipPrefix: "",
      payslipCounter: "",
      dateFormat: "",
    };
    let isValid = true;

    const employeePrefix = sanitizePrefixValue(formats.employeePrefix || "");
    const payslipPrefix = sanitizePrefixValue(formats.payslipPrefix || "");

    if (!employeePrefix.trim()) {
      errors.employeePrefix = "Employee prefix is required.";
      isValid = false;
    } else if (employeePrefix.length < MIN_PREFIX_LENGTH || employeePrefix.length > MAX_PREFIX_LENGTH) {
      errors.employeePrefix = "Employee prefix must be 2-6 characters.";
      isValid = false;
    } else if (!/^[A-Z]+$/.test(employeePrefix)) {
      errors.employeePrefix = "Use uppercase letters only.";
      isValid = false;
    }

    if (!formats.employeeCounter?.trim()) {
      errors.employeeCounter = "Employee next number is required.";
      isValid = false;
    } else if (!/^\d+$/.test(formats.employeeCounter.trim())) {
      errors.employeeCounter = "Use digits only.";
      isValid = false;
    } else if (parseInt(formats.employeeCounter.trim(), 10) < 1) {
      errors.employeeCounter = "Next number must be at least 1.";
      isValid = false;
    }

    if (!payslipPrefix.trim()) {
      errors.payslipPrefix = "PaySlip prefix is required.";
      isValid = false;
    } else if (payslipPrefix.length < MIN_PREFIX_LENGTH || payslipPrefix.length > MAX_PREFIX_LENGTH) {
      errors.payslipPrefix = "PaySlip prefix must be 2-6 characters.";
      isValid = false;
    } else if (!/^[A-Z]+$/.test(payslipPrefix)) {
      errors.payslipPrefix = "Use uppercase letters only.";
      isValid = false;
    }

    if (!formats.payslipCounter?.trim()) {
      errors.payslipCounter = "PaySlip next number is required.";
      isValid = false;
    } else if (!/^\d+$/.test(formats.payslipCounter.trim())) {
      errors.payslipCounter = "Use digits only.";
      isValid = false;
    } else if (parseInt(formats.payslipCounter.trim(), 10) < 1) {
      errors.payslipCounter = "Next number must be at least 1.";
      isValid = false;
    }

    if (!ALLOWED_DATE_FORMATS.includes(formats.dateFormat)) {
      errors.dateFormat = "Select a valid date format.";
      isValid = false;
    }

    return { errors, isValid };
  };

  const areNumberFormatsEqual = (a, b) => {
    if (!a || !b) return false;
    return (
      a.employeePrefix === b.employeePrefix &&
      a.employeeCounter === b.employeeCounter &&
      a.payslipPrefix === b.payslipPrefix &&
      a.payslipCounter === b.payslipCounter &&
      a.dateFormat === b.dateFormat
    );
  };

  const applyNumberFormatState = (formats, originalOverride) => {
    const { errors, isValid } = validateNumberFormats(formats);
    setNumberFormatErrors(errors);
    setIsNumberFormatValid(isValid);

    if (originalOverride) {
      setNumberFormatsOriginal(originalOverride);
      setIsNumberFormatDirty(false);
    } else {
      if (numberFormatsOriginal) {
        setIsNumberFormatDirty(!areNumberFormatsEqual(numberFormatsOriginal, formats));
      } else {
        const hasValues = Object.values(formats).some(
          (value) => value && value.trim() !== ""
        );
        setIsNumberFormatDirty(hasValues);
      }
    }
  };

  const formatCounterValue = (counter) => {
    if (counter === undefined || counter === null || Number.isNaN(counter)) {
      return "";
    }
    return String(counter);
  };

  const getAccountSettings = async () => {
    try {
      const result = await AuthService.getAccountSetting();
      if (result?.success && result?.data) {
        const country = result?.data?.country || "";
        setAccountCountry(country);
        if (country) localStorage.setItem("companyCountry", country);
      }
    } catch (error) {
      // Silently fail, country will be empty
    }
  };

  const getCompanySettingsConfig = async () => {
    LoaderHelper.loaderStatus(true);
    setNumberFormatsLoading(true);
    try {
      const result = await AuthService.getCompanySettings(companyToken);
      if (result?.success) {
        const data = result?.data;
        if (data) {
          setSettingsId(data?._id || "");
          const mappedFormats = {
            employeePrefix: data?.employeeNumber?.prefix || "",
            employeeCounter: formatCounterValue(data?.employeeNumber?.counter),
            payslipPrefix: data?.payslipNumber?.prefix || "",
            payslipCounter: formatCounterValue(data?.payslipNumber?.counter),
            dateFormat: ALLOWED_DATE_FORMATS.includes(data?.dateFormat)
              ? data.dateFormat
              : "DD/MM/YYYY",
          };
          const uppercasedFormats = {
            employeePrefix: sanitizePrefixValue(mappedFormats.employeePrefix),
            employeeCounter: mappedFormats.employeeCounter,
            payslipPrefix: sanitizePrefixValue(mappedFormats.payslipPrefix),
            payslipCounter: mappedFormats.payslipCounter,
            dateFormat: mappedFormats.dateFormat,
          };
          setNumberFormats(uppercasedFormats);
          applyNumberFormatState(uppercasedFormats, uppercasedFormats);
        } else {
          setSettingsId("");
          setNumberFormatsOriginal(null);
          const blankFormats = {
            employeePrefix: "",
            employeeCounter: "",
            payslipPrefix: "",
            payslipCounter: "",
            dateFormat: "DD/MM/YYYY",
          };
          setNumberFormats(blankFormats);
          applyNumberFormatState(blankFormats, null);
        }
      }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert("Unable to load number format settings.", "error");
    } finally {
      setNumberFormatsLoading(false);
    }
  };

  const handleNumberFormatChange = (field, value) => {
    const valueToStore =
      field === "employeePrefix" || field === "payslipPrefix"
        ? sanitizePrefixValue(value)
        : value;
    setNumberFormats((prev) => {
      const updated = {
        ...prev,
        [field]: valueToStore,
      };
      applyNumberFormatState(updated);
      return updated;
    });
  };

  const handleNumberFormatSave = async () => {
    const { errors, isValid } = validateNumberFormats(numberFormats);
    setNumberFormatErrors(errors);
    if (!isValid) {
      showAlert("Fix validation errors before saving number formats.", "error");
      return;
    }

    const payload = {
      employeeNumber: {
        prefix: sanitizePrefixValue(numberFormats.employeePrefix).trim(),
        counter: numberFormats.employeeCounter.trim(),
      },
      payslipNumber: {
        prefix: sanitizePrefixValue(numberFormats.payslipPrefix).trim(),
        counter: numberFormats.payslipCounter.trim(),
      },
      dateFormat: numberFormats.dateFormat,
    };

    setNumberFormatsSaving(true);
    LoaderHelper.loaderStatus(true);

    try {
      const result = settingsId
        ? await AuthService.updateCompanySettings(settingsId, payload, companyToken)
        : await AuthService.createCompanySettings(payload, companyToken);

      if (result?.success) {
        showAlert(result?.message || "Number formats updated successfully.", "success");
        setDateFormat(payload.dateFormat);
        await getCompanySettingsConfig();
      } else {
        showAlert(result?.message || "Unable to update number formats.", "error");
      }
    } catch (error) {
      showAlert("Unable to update number formats.", "error");
    } finally {
      LoaderHelper.loaderStatus(false);
      setNumberFormatsSaving(false);
    }
  };
  const getMarketingNotification = async () => {
    if (!companyId) return;

    try {
      const result = await AuthService.getMarketingCommunication(companyId);
      if (result?.success && result?.data) {
        setMarketingReceive(result.data.receive ?? true);
      }
    } catch (error) {
      console.error("Failed to fetch marketing preference", error);
    }
  };

  const updateMarketingNotification = async (receive) => {
    if (!companyId) return;

    setMarketingLoading(true);
    try {
      const result = await AuthService.updateMarketingCommunication(companyId, { receive });
      if (result?.success) {
        setMarketingReceive(receive);
        showAlert(result?.message || "Marketing notification preference updated", "success");
      } else {
        showAlert(result?.message || "Failed to update", "error");
      }
    } catch (error) {
      showAlert("Something went wrong", "error");
    } finally {
      setMarketingLoading(false);
    }
  };

  const isNumberFormatSaveDisabled =
    numberFormatsLoading ||
    numberFormatsSaving ||
    !isNumberFormatValid ||
    !isNumberFormatDirty;

  return (
    <AdditionaLInfo
      setDpOpen={setDpOpen}
      updateDepartment={updateDepartment}
      departmentData={departmentData}
      deleteDepartment={deleteDepartment}
      dpopen={dpopen}
      handleDepartment={handleDepartment}
      operatorData={operatorData}
      operatorEmployees={operatorEmployees}
      roleOpen={roleOpen}
      setRoleOpen={setRoleOpen}
      getOperatorEmployees={getOperatorEmployees}
      createOperator={createOperator}
      updateOperator={updateOperator}
      deleteOperator={deleteOperator}
      handleScheduleTime={handleScheduleTime}
      ScheduleData={scheduleData}
      loadingUt={loadingUt}
      updateLeaveType={updateLeaveType}
      deleteLeaveType={deleteLeaveType}
      leaveData={leaveData}
      handleAccountLeaveType={handleLeaveType}
      loading={loading}
      open={open}
      setOpen={setOpen}
      utopen={utopen}
      setUtOpen={setUtOpen}
      unitData={unitData}
      handleUnitType={handleUnitType}
      deleteUnitType={deleteUnitType}
      updateUnitType={updateUnitType}
      updatePensionType={updatePensionType}
      pensionData={pension}
      deletePensionType={deletePensionType}
      pensionopen={pensionopen}
      setPensionOpen={setPensionOpen}
      handlePensionType={handlePensionType}
      updateDeductionType={updateDeductionType}
      deductionData={deductionData}
      deleteDeductionType={deleteDeductionType}
      deductionOpen={deductionOpen}
      setDeductionOpen={setDeductionOpen}
      handleDeductionType={handleDeductionType}
      updateFringeType={updateFringeType}
      fringeData={fringeData}
      deleteFringeType={deleteFringeType}
      fringeOpen={fringeOpen}
      setFringeOpen={setFringeOpen}
      handleFringeType={handleFringeType}
      updateTaxYear={updateTaxYear}
      taxData={taxData}
      deleteTaxYear={deleteTaxYear}
      taxOpen={taxOpen}
      setTaxOpen={setTaxOpen}
      handleTaxYear={handleTaxYear}
      payslipData={payslipData}
      handlePayslip={handlePayslip}
      handlePayslipShow={handlePayslipShow}
      handlePayslipShowEmptyValues={handlePayslipShowEmptyValues}
      payslipShow={payslipShow}
      updateHoliday={updateHoliday}
      holiday={holiday}
      deleteHoliday={deleteHoliday}
      handleHoliday={handleHoliday}
      holidayOpen={holidayOpen}
      setHolidayOpen={setHolidayOpen}
      getHolidayType={getHolidayType}
      holidayTypes={holidayType}
      allowanceType={allowanceType}
      allowanceOpen={allowanceOpen}
      setAllowanceOpen={setAllowanceOpen}
      handleAddAllowance={handleAddAllowance}
      updateAllowanceType={updateAllowanceType}
      deleteAllowanceType={deleteAllowanceType}
      contributionType={contributionType}
      setContributionsOpen={setContributionsOpen}
      contributionsOpen={contributionsOpen}
      handleAddContributions={handleAddContributions}
      updateContributions={updateContributions}
      deleteContributions={deleteContributions}
      leviesTypes={leviesType}
      handleAddLevies={handleAddLevies}
      updateLevies={updateLevies}
      deleteLevies={deleteLevies}
      creditTypes={creditType}
      updateCreditType={updateCreditType}
      deleteCreditType={deleteCreditType}
      handleAddCreditType={handleAddCreditType}
      numberFormats={numberFormats}
      numberFormatsLoading={numberFormatsLoading}
      numberFormatsSaving={numberFormatsSaving}
      numberFormatErrors={numberFormatErrors}
      isNumberFormatSaveDisabled={isNumberFormatSaveDisabled}
      handleNumberFormatChange={handleNumberFormatChange}
      handleNumberFormatSave={handleNumberFormatSave}
      accountCountry={accountCountry}
      marketingReceive={marketingReceive}
      setMarketingReceive={setMarketingReceive}
      updateMarketingNotification={updateMarketingNotification}
      marketingLoading={marketingLoading}
    // isEditable={isEditable}
    />
  );
};

export default AdditionalInfo;
